import React from 'react';
import PropTypes from 'prop-types';

class Loader extends React.Component {
  constructor(props) {
    super(props);

    this.state = this.resolveState(props);
  }

  UNSAFE_componentWillReceiveProps(props) {
    this.setState(this.resolveState(props));
  }

  resolveState(props) {
    return { loading: props.loading };
  }

  render() {
    if (this.state.loading) {
      return (
        <div className="content-loader">
          <span className="content-loader__container">
            <span>Processing...</span>

            <span className="content-loader__circle-01"></span>
            <span className="content-loader__circle-02"></span>
            <span className="content-loader__circle-03"></span>
          </span>
        </div>
      );
    }

    return this.props.children;
  }
}

Loader.defaultProps = {
  loading: false
};

Loader.propTypes = {
  loading: PropTypes.bool,
  children: PropTypes.any.isRequired
};

export default Loader;
